import React from "react";

import "./headerLogo.css";

function Heading() {
  return (
    <header className="App-header">
      <h1>CYF hotel</h1>
      <img className="crownImage" src="/images/crown1.png" alt="website-logo" />
    </header>
  );
}

export default Heading;
